@use '@/styles/tokens' as *;

.title {
  margin: 0;
  font-size: $font-size-2xl;
  font-weight: $font-weight-regular;
  padding: 0 var(--space-6);
}

.grid {
  padding: 0 0 0 var(--space-6);
}
